var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.178 3.76H8.668A2.585 2.585 0 006.22 2a2.585 2.585 0 00-2.447 1.76H1.821a.821.821 0 000 1.643h1.953a2.585 2.585 0 002.447 1.76 2.585 2.585 0 002.446-1.76h12.511a.821.821 0 100-1.643zM6.221 5.52a.94.94 0 010-1.877.94.94 0 010 1.876zm14.957 5.279h-1.953a2.585 2.585 0 00-2.446-1.76 2.585 2.585 0 00-2.446 1.76H1.82a.821.821 0 000 1.642h12.512a2.585 2.585 0 002.446 1.76 2.585 2.585 0 002.447-1.76h1.953a.821.821 0 100-1.643zm-4.399 1.76a.94.94 0 010-1.877.94.94 0 010 1.876zm4.399 5.279h-8.991a2.585 2.585 0 00-2.447-1.76 2.585 2.585 0 00-2.446 1.76H1.82a.821.821 0 000 1.642h5.473a2.585 2.585 0 002.446 1.76 2.585 2.585 0 002.447-1.76h8.992a.822.822 0 000-1.642zM9.74 19.598a.94.94 0 010-1.877.94.94 0 010 1.876z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0d862621f5764570ce7e9b7befd39e99.svg";
export { ForwardRef as ReactComponent };